import Bb from '../../config/backbone'
import dispatcher from '../../dispatcher'

//picking
//ready
//started
//ended


const Game = Bb.Model.extend({
    defaults: {
        status: 'picking', //ended
    },
    initialize(){
        Bb.Model.prototype.initialize.apply(this, arguments)
        this.listenTo(this, 'change', ()=> {
            dispatcher.emit('game:changed')
        })
    },
    reset (p) {
        this.clear()
        this.set(Object.assign({}, this.defaults, p))
        //console.log(this.toJSON())
    }
})


export default Game







// WEBPACK FOOTER //
// ./src/game/config/Game.js